'use client';
/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { ArrowForwardIcon } from '@chakra-ui/icons';

/* Services */

/**
 * Renders ScrollToTop
 * @returns {ReactElement} ScrollToTop
 */
export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  // Top: 0 takes us all the way back to the top of the page
  // Behavior: smooth keeps it smooth!
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    // Button is displayed after scrolling for 500 pixels
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // scroll-to-top classes: fixed, bottom:0, right:0
  return (
    <Box>
      {isVisible && (
        <Box
          pos="fixed"
          w="48px"
          h="48px"
          right="30px"
          bottom="65px"
          borderRadius="25px"
          bg={'#FEFAF6'}
          cursor="pointer"
          display="flex" // Enable flexbox
          alignItems="center" // Center items vertically
          justifyContent="center"
          transform="rotate(270deg)"
          zIndex="100"
          onClick={scrollToTop}
        >
          <ArrowForwardIcon boxSize="24px" color={'#010509'} />
        </Box>
      )}
    </Box>
  );
}
